import React, { useState } from 'react'
import Colors from 'colors.json'

import Input from 'components/Input'
import Button from 'components/Button'
import { Form, Formik } from 'formik'

import { CreateDrdMemberSchemas } from 'schemas/createMemberSchemas'
import { useCreateDrdMember } from './useCreateDrdMember'

import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Index: React.FC<{ onCloseModal: () => void }> = ({
  onCloseModal,
}): React.ReactElement => {
  // STATES
  const [isAddress, isAddressSet] = useState<boolean>(false)
  const {
    initialValues,
    handleSubmitCreateDrdMember,
  } = useCreateDrdMember(onCloseModal)

  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev)
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={CreateDrdMemberSchemas}
      onSubmit={(values, actions) => {
        console.log('Form submitted with values:', values)
        handleSubmitCreateDrdMember(values, actions)
      }}
    >
      {({ isSubmitting, setFieldValue }) => {
        return (
          <Form>
            <div className="mb-2">
              <Input
                name="ident"
                label="Ident"
                labelClassName="text-gray-500"
              />
              <div className="relative mb-5">
                <div className="w-full">
                  <label
                    htmlFor="password"
                    className="block mb-2 text-gray-500 font-light"
                  >
                    Password (optional)
                  </label>
                  <input
                    id="password"
                    name="password"
                    type="text"
                    autoComplete="off"
                    className="block w-full p-2 text-black tracking-wider border border-gray-600 focus:border-primary"
                    style={{
                      ...(!showPassword ? { WebkitTextSecurity: 'disc', fontFamily: 'text-security-disc' } : {})
                    } as React.CSSProperties}
                    onSelect={(data) =>
                      setFieldValue('password', (data.target as HTMLInputElement).value)
                    }
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute right-3 text-gray-500"
                    style={{ top: '2.3rem' }}
                    aria-label="Toggle password visibility"
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
              </div>
              <div className="flex  gap-4 items-center">
                <Input
                  name="firstName"
                  label="First Name"
                  labelClassName="text-gray-500 w-full"
                />
                <Input
                  name="lastName"
                  label="Last Name"
                  labelClassName="text-gray-500 w-full"
                />
              </div>

              <br />

              <div className="flex gap-2 mb-4">
                <input
                  type={'checkbox'}
                  onClick={() => isAddressSet(!isAddress)}
                />
                <span className="font-light">Add more details</span>
              </div>
              {isAddress ? (
                <>
                  <Input
                    name="address1"
                    label="Address 1"
                    labelClassName="text-gray-500"
                  />
                  <Input
                    name="address2"
                    label="Address 2"
                    labelClassName="text-gray-500"
                  />
                  <Input
                    name="address3"
                    label="Address 3"
                    labelClassName="text-gray-500"
                  />
                  <Input
                    name="address4"
                    label="Address 4"
                    labelClassName="text-gray-500"
                  />
                  <Input
                    name="suburb"
                    label="Suburb"
                    labelClassName="text-gray-500"
                  />
                  <div className="flex gap-4 items-center">
                    <Input
                      name="state"
                      label="State"
                      labelClassName="text-gray-500"
                    />
                    <Input
                      name="city"
                      label="City"
                      labelClassName="text-gray-500"
                    />
                    <Input
                      name="postCode"
                      label="Postal Code"
                      labelClassName="text-gray-500"
                    />
                  </div>
                  <br />
                  <Input
                    name="comments"
                    label="Comments"
                    labelClassName="text-gray-500"
                  />
                </>
              ) : null}
            </div>

            <footer className="flex justify-end pb-4 pl-4 pr-4">
              <Button
                type="submit"
                className="mr-2 rounded bg-primary"
                disabled={isSubmitting}
              >
                <span className="tracking-wider font-bold">Confirm</span>
              </Button>
              <Button
                className="bg-white border rounded border-primary"
                onClick={onCloseModal}
                style={{ color: Colors.primary }}
              >
                <span className="tracking-wider font-bold">Cancel</span>
              </Button>
            </footer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Index
